/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Trainer_Reply_HintInputs */

const en_us2_profile_trainer_reply_hint = /** @type {(inputs: Profile_Trainer_Reply_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When an answer is ready and you are not in the app.`)
};

const pt_br2_profile_trainer_reply_hint = /** @type {(inputs: Profile_Trainer_Reply_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando a resposta fica pronta e você não está no app.`)
};

const es_419_profile_trainer_reply_hint = /** @type {(inputs: Profile_Trainer_Reply_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando una respuesta esté lista y no estés en la app.`)
};

const pt_pt2_profile_trainer_reply_hint = /** @type {(inputs: Profile_Trainer_Reply_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando a resposta fica pronta e não estás na app.`)
};

const fr_fr2_profile_trainer_reply_hint = /** @type {(inputs: Profile_Trainer_Reply_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand une réponse est prête et que tu n'es pas dans l'app.`)
};

const de_de2_profile_trainer_reply_hint = /** @type {(inputs: Profile_Trainer_Reply_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn eine Antwort fertig ist und du nicht in der App bist.`)
};

const it_it2_profile_trainer_reply_hint = /** @type {(inputs: Profile_Trainer_Reply_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando una risposta è pronta e non sei nell'app.`)
};

/**
* | output |
* | --- |
* | "When an answer is ready and you are not in the app." |
*
* @param {Profile_Trainer_Reply_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_trainer_reply_hint = /** @type {((inputs?: Profile_Trainer_Reply_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Trainer_Reply_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_trainer_reply_hint(inputs)
	if (locale === "es-419") return es_419_profile_trainer_reply_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_trainer_reply_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_trainer_reply_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_trainer_reply_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_trainer_reply_hint(inputs)
	return en_us2_profile_trainer_reply_hint(inputs)
});
export { profile_trainer_reply_hint as "profile.trainer_reply_hint" }